import { Button, Paper, Skeleton, ThemeProvider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useCustomTheme } from "services/hooks";
import { get, IGetPurchaseResponse } from "services/purchase";
import { useAppSelector } from "store/hooks";
import styles from "./confirmation.module.scss";

const Confirmation = () => {
  const [ purchase, setPurchase ] = useState<IGetPurchaseResponse | null>(null);
  const customTheme = useCustomTheme();
  const { jwt, isLoading } = useAppSelector((state) => state.app);
  const { id } = useParams<{ id:string }>();

  useEffect(() => {
    if(!isLoading && jwt) {
      handleGetPurchase();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isLoading, jwt])

  const handleGetPurchase = async () => {
    try {
      const response = await get(id,jwt!);
      setPurchase(response);
      sessionStorage.removeItem("cb_checkout_S");
      sessionStorage.removeItem("cb_checkout_Y");
    } catch(err) {
      console.log(err);
    }
  }

  return (
    <>
      <div className="container h-100">
        <div className={`${styles.confirmation} row justify-content-center h-100 align-items-center`}>
          <div className="col-lg-8 col-xl-6 col-12 text-center">
            <ThemeProvider theme={customTheme}>
              <Paper elevation={3} className={`${styles.paper}`}>
                {
                  isLoading ? (
                    <><Skeleton/></>
                  ) : (
                    <>
                      <Typography variant="h5" fontWeight="700" mb={1}>Congratulations!</Typography>
                      <Typography variant="body1" mb={1}>
                        Your purchase of <strong>{purchase?.amount_total} Mangrove Trees</strong> has been successfully completed. Thank you for your contribution towards a greener planet!
                      </Typography>
                      <Button
                        component={Link}
                        className="my-2"
                        to="/"
                        variant="contained"
                        size="small"
                        disableElevation
                      >
                        Go to Main Page
                      </Button>
                    </>
                  )
                }
                
              </Paper>
            </ThemeProvider>
          </div>
        </div>
      </div>
    </>
  )
};

export default Confirmation;
